module.exports = __webpack_public_path__ + "bradavice_6_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_6_before.jpg
// module id = 940
// module chunks = 0